/* NOTE: Both lines are required due to current React version */
/* eslint-disable react/no-find-dom-node */
/* eslint-disable react/no-string-refs */
import * as React from 'react';

import { classes, style } from 'typestyle';
import { StripeLogo } from '../../components/stripe-logo';
import couponImg from '../../static/local_offer.svg';

import { styles } from './styles';
import { formatCurrency } from '../../lib/currency';
import { CheckoutModel, ORDER_STATE } from '../../modules/checkout/model';
import { LabelledCheckbox } from '../form/labelled-checkbox';
import { UserModel } from '../../modules/user/model';
import { CheckoutActions } from './checkout-actions';
import { CouponForm } from './coupon-form';
import { Component, deps, inject, observer } from '../../lib/component';

interface CheckoutSummaryPanelProps {
  userModel: UserModel;
  checkoutModel: CheckoutModel;
  hasRightsholders: boolean;
  eula: boolean;
  rightsholders: boolean;
  error: boolean;
  handleCheckout: (event: any, ref?: any) => void;
  handleCheckboxChange: (type: any, checked: any) => void;
  handleRightsholderRequest: () => void;
}

@inject(deps)
@observer
export class CheckoutSummaryPanel extends Component<CheckoutSummaryPanelProps> {
  summaryDiv: HTMLElement;

  constructor(props) {
    super(props);
  }

  handleRighstholderRequest(event?: React.MouseEvent<any>) {
    if (event) {
      event.preventDefault();
    }
    this.props.handleRightsholderRequest();
  }

  render() {
    const {
      checkoutModel,
      hasRightsholders,
      eula,
      rightsholders,
      error,
      handleCheckboxChange,
      handleCheckout,
      handleRightsholderRequest,
      model,
    } = this.props;

    const { checkout } = model;

    return (
      <div className={styles.checkoutSummary} ref={(ref) => (this.summaryDiv = ref)}>
        <div className={classes(styles.checkoutSummaryItem, style({ textAlign: 'left' }))}>
          <LabelledCheckbox
            checked={eula}
            isValid={!error || (error && eula)}
            onChange={() => handleCheckboxChange('eula', eula)}
          >
            I have read the license agreement for tracks in my basket
          </LabelledCheckbox>
          {hasRightsholders && (
            <LabelledCheckbox
              checked={rightsholders}
              isValid={!error || (error && rightsholders)}
              onChange={() => handleCheckboxChange('rightsholders', rightsholders)}
            >
              I have read the additional{' '}
              <a href="#" onClick={this.handleRighstholderRequest.bind(this)}>
                rightsholders terms
              </a>
            </LabelledCheckbox>
          )}
          {error ? <span className={styles.errorMessageLeft}>Please agree to the terms</span> : null}
        </div>
        <div className={styles.checkoutSummaryItem}>
          <p className={styles.couponMessage}>
            <img src={couponImg} />
            Discount{' '}
            <span>
              {checkoutModel.couponText && 'discount' in checkoutModel.couponText
                ? checkoutModel.couponText.discount
                : ''}
            </span>
          </p>
          <CouponForm />
        </div>
        <div className={styles.checkoutSummaryItem}>
          <span className={classes(styles.totalText, styles.smallText)}>Coupon</span>
          <span className={classes(styles.totalText, styles.smallText)}>
            -{formatCurrency(checkoutModel.discountAmount, checkoutModel.currency)}
          </span>
        </div>
        <div className={styles.checkoutSummaryItem}>
          {checkout.orderState === ORDER_STATE.ERROR ? (
            <span className={styles.errorMessage}>{checkout.globalError || 'An unknown error occurred'}</span>
          ) : null}
          <CheckoutActions eula={eula} rightsholders={rightsholders} handleCheckout={handleCheckout} />
          <div className={styles.stripeLogo}>
            <StripeLogo type="dark" />
          </div>
        </div>
      </div>
    );
  }
}
